import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6b90a97b")

_pushScopeId("data-v-6b90a97b")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col left-arrow" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "create-parag" }
const _hoisted_11 = { class: "news-create-heading" }
const _hoisted_12 = { class: "create-parag" }
const _hoisted_13 = { class: "news-create-heading" }
const _hoisted_14 = { class: "edit-date" }
const _hoisted_15 = { class: "input-container" }
const _hoisted_16 = { class: "input-container__border" }
const _hoisted_17 = { class: "create-parag" }
const _hoisted_18 = { class: "edit-image" }
const _hoisted_19 = { for: "" }
const _hoisted_20 = { class: "path-image" }
const _hoisted_21 = { class: "added-image" }
const _hoisted_22 = { class: "path-div" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "create-parag" }, "Текст", -1)
const _hoisted_24 = { id: "app" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "create-parag" }, "seo title", -1)
const _hoisted_26 = { class: "path-image" }
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { class: "create-parag" }, "seo description", -1)
const _hoisted_28 = { class: "path-image" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "create-parag" }, "seo keywords", -1)
const _hoisted_30 = { class: "path-image" }
const _hoisted_31 = { class: "path-image" }
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = { class: "article-show" }
const _hoisted_34 = { class: "create-parag" }
const _hoisted_35 = {
  key: 0,
  class: "window-article"
}
const _hoisted_36 = { class: "create-parag window-article__create-parag" }
const _hoisted_37 = { class: "window-article__heading" }
const _hoisted_38 = { class: "window-article__subtitle" }
const _hoisted_39 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_40 = { class: "modal-content" }
const _hoisted_41 = { class: "modalcontent" }
const _hoisted_42 = { class: "modalcontent__h2" }
const _hoisted_43 = {
  key: 0,
  class: "errorCreate"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_quill_editor = _resolveComponent("quill-editor")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/admin/articles/",
            class: "link section__link create-article-link"
          }, {
            default: _withId(() => [
              _createVNode(_component_svg_icon, { name: "arrow-left" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('login.back')), 1 /* TEXT */)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("h1", null, _toDisplayString(_ctx.$t('panelAdminArticles.createArticle')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("form", {
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"])),
            class: "form login__form",
            id: "formElement"
          }, [
            _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('admin.title')), 1),
            _createVNode("div", _hoisted_11, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.data.heading = $event))
              }, null, 512), [
                [_vModelText, _ctx.data.heading]
              ])
            ]),
            _createVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('admin.subtitle')), 1),
            _createVNode("div", _hoisted_13, [
              _withDirectives(_createVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.data.Subtitle = $event))
              }, null, 512), [
                [_vModelText, _ctx.data.Subtitle]
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _withDirectives(_createVNode("input", {
                    type: "date",
                    name: "trip-start",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.data.date = $event)),
                    class: "edit-date__calendar"
                  }, null, 512), [
                    [_vModelText, _ctx.data.date]
                  ])
                ])
              ])
            ]),
            _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('admin.image')), 1),
            _createVNode("div", _hoisted_18, [
              _createVNode("label", _hoisted_19, [
                _createVNode(_component_svg_icon, { name: "imagePath" }),
                _createVNode("input", {
                  class: "file-ip-1 custom-file-input",
                  type: "file",
                  onChange: _cache[4] || (_cache[4] = (...args) => (_ctx.fileChange(...args))),
                  name: "file",
                  id: "fileItem"
                }, null, 32)
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode("img", {
                  src: _ctx.imagePreview,
                  alt: "",
                  srcset: ""
                }, null, 8, ["src"])
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("div", _hoisted_24, [
                _createVNode(_component_quill_editor, {
                  theme: "snow",
                  toolbar: "full",
                  content: _ctx.html,
                  "onUpdate:content": _cache[5] || (_cache[5] = $event => (_ctx.html = $event)),
                  contentType: "html"
                }, null, 8, ["content"])
              ])
            ]),
            _createVNode("div", null, [
              _hoisted_25,
              _createVNode("div", _hoisted_26, [
                _withDirectives(_createVNode("textarea", {
                  type: "text",
                  class: "seo-input",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.data.seo_title = $event))
                }, null, 512), [
                  [_vModelText, _ctx.data.seo_title]
                ])
              ])
            ]),
            _hoisted_27,
            _createVNode("div", _hoisted_28, [
              _withDirectives(_createVNode("textarea", {
                type: "text",
                class: "seo-input",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.data.seo_description = $event))
              }, null, 512), [
                [_vModelText, _ctx.data.seo_description]
              ])
            ]),
            _hoisted_29,
            _createVNode("div", _hoisted_30, [
              _withDirectives(_createVNode("textarea", {
                type: "text",
                class: "seo-input",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.data.seo_keywords = $event))
              }, null, 512), [
                [_vModelText, _ctx.data.seo_keywords]
              ])
            ]),
            _createVNode("div", _hoisted_31, [
              _createVNode("button", {
                class: "button-using",
                type: "submit",
                onClick: _cache[9] || (_cache[9] = $event => {;(_ctx.changeactive = !_ctx.changeactive), _ctx.createArticle()})
              }, _toDisplayString(_ctx.$t('panelAdminArticles.saveNews')), 1),
              _createVNode("button", {
                class: "button-change",
                onClick: _cache[10] || (_cache[10] = $event => (_ctx.changeArticle()))
              }, _toDisplayString(_ctx.$t('profile.cancel')), 1)
            ])
          ], 32)
        ]),
        _createVNode("div", _hoisted_32, [
          _createVNode("div", _hoisted_33, [
            _withDirectives(_createVNode("input", {
              type: "checkbox",
              class: "article-show-checkbox",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (_ctx.data.checked = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.data.checked]
            ]),
            _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('panelAdminArticles.Preview')), 1)
          ]),
          (_ctx.data.checked)
            ? (_openBlock(), _createBlock("div", _hoisted_35, [
                _createVNode("img", { src: _ctx.imagePreview }, null, 8, ["src"]),
                _createVNode("p", _hoisted_36, " От Туризм | " + _toDisplayString(_ctx.data.date), 1),
                _createVNode("p", _hoisted_37, _toDisplayString(_ctx.data.heading), 1),
                _createVNode("p", _hoisted_38, _toDisplayString(_ctx.data.Subtitle), 1),
                _createVNode("p", {
                  class: "window-article__text",
                  innerHTML: _ctx.html
                }, null, 8, ["innerHTML"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.changeactive)
      ? (_openBlock(), _createBlock("div", _hoisted_39, [
          _createVNode("div", _hoisted_40, [
            (_ctx.errorExit)
              ? (_openBlock(), _createBlock("span", {
                  key: 0,
                  class: "close",
                  onClick: _cache[13] || (_cache[13] = $event => (_ctx.changeactive = !_ctx.changeactive))
                }, "×"))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_41, [
              _createVNode("h2", _hoisted_42, _toDisplayString(_ctx.$t('panelAdminArticles.LoadingWait')), 1),
              (_ctx.errorMessage)
                ? (_openBlock(), _createBlock("p", _hoisted_43, _toDisplayString(_ctx.$t('panelAdminArticles.errorOccurred')), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
})